import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useOrgId } from 'hooks/useOrg';
import { isRegularOrg } from 'domains/orgDomain';
import MatBaseSelect from './MatBaseSelect';
import MatAdminTable from './MatAdminTable';
import MatItemForm from './MatItemForm';
import { useUnmount } from 'ahooks';
import { useEffect } from 'react';

const MatAdmin = () => {
  const orgId = useOrgId();
  const regular = isRegularOrg({ id: orgId });
  const curItem = useAppSelector((state) => state.mat.item);
  const dispatch = useAppDispatch();

  useUnmount(() => {
    dispatch.mat.reset();
    dispatch.app.setState({
      filterForceHidden: false,
    });
  });

  useEffect(() => {
    if (curItem) {
      dispatch.app.setState({
        filterForceHidden: true,
      });
    } else {
      dispatch.app.setState({
        filterForceHidden: false,
      });
    }
  }, [curItem, dispatch.app]);

  return (
    <>
      {curItem && <MatItemForm />}
      {regular && <MatBaseSelect />}
      <MatAdminTable />
    </>
  );
};

export default MatAdmin;
